import {Directive, EventEmitter, Input, Output} from '@angular/core';
import {Router} from '@angular/router';
import {StorageService} from '../services/storage.service';
import {SiStorageItem} from '../models/storage.model';

@Directive({
  selector: '[siStorage]'
})
export class StorageDirective {
  @Input() siStorageName: string;
  @Input() siStorageLocal: boolean;

  // If true, the storage variable affects the entire application. If false, the storage variable only affects the current route.
  @Input() siStorageGlobal = false;
  @Output() siStorageModelChange = new EventEmitter<any>();
  @Output() siStorageNoItemChange = new EventEmitter<any>();
  currentUrl: string;
  storageAppliedFlag = false;
  private _siStorageModel: any;
  private _siStorageManualSet: number;

  constructor(
    private router: Router,
    private storageService: StorageService
  ) {
  }

  get siStorageModel(): any {
    return this._siStorageModel;
  }

  @Input()
  set siStorageModel(val) {
    this._siStorageModel = val;
    if (this.storageAppliedFlag) {
      if (this.siStorageManualSet === undefined) {
        this.setStorageItem();
      }

      return;
    }

    this.storageAppliedFlag = true;
    this.getStorageItem();
  }

  get siStorageManualSet(): number {
    return this._siStorageManualSet;
  }

  @Input()
  set siStorageManualSet(val) {
    this._siStorageManualSet = val;
    if (val) {
      this.setStorageItem();
    }
  }

  getStorageName(): string {
    if (this.siStorageGlobal) {
      return this.siStorageName;
    }

    this.currentUrl = this.currentUrl || this.router.url;
    return this.siStorageName ? `${this.currentUrl}-${this.siStorageName}` : `${this.currentUrl}`;
  }

  getStorageItem(): void {
    const storageName = this.getStorageName();
    const storageItem = this.storageService.getItem(storageName, this.siStorageLocal);
    if (!storageItem) {
      setTimeout(() => {
        this.siStorageNoItemChange.emit();
      });
      return;
    }

    setTimeout(() => {
      this.clearModel();
      this.assignModel(this.parseFromStorageItem(storageItem));
      this.siStorageModelChange.emit(this._siStorageModel);
    });
  }

  setStorageItem(): void {
    const storageName = this.getStorageName();
    this.storageService.setItem(storageName, JSON.stringify(this.parseToStorageItem(this.siStorageModel)), this.siStorageLocal);
  }

  parseToStorageItem(item: any): SiStorageItem {
    return {
      value: item
    } as SiStorageItem;
  }

  parseFromStorageItem(item: string): any {
    if (!item) {
      return null;
    }

    try {
      const parsedItem = JSON.parse(item);
      return parsedItem.value;
    } catch (e) {
      return null;
    }
  }

  clearModel(): void {
    if (Array.isArray(this._siStorageModel)) {
      this._siStorageModel.length = 0;
    } else if (this._siStorageModel !== null && this._siStorageModel !== undefined && typeof this._siStorageModel === 'object') {
      Object.keys(this._siStorageModel).forEach(key => delete this._siStorageModel[key]);
    } else {
      this._siStorageModel = null;
    }
  }

  assignModel(item: any): void {
    if (this._siStorageModel !== null && this._siStorageModel !== undefined && (Array.isArray(item) || typeof item === 'object')) {
      Object.assign(this._siStorageModel, item);
    } else {
      this._siStorageModel = item;
    }
  }
}
